/** Assistant steps waiting for a person, as rows for Overview's Needs you. */
import { useMemo } from 'react';
import type { NeedItem } from '../overview/needsYou.ts';
import { useAssistantPending } from './data.ts';
import { assistantNeeds } from './model.ts';

export function useAssistantNeedItems(): NeedItem[] {
  const pending = useAssistantPending();
  return useMemo(() => assistantNeeds(pending), [pending]);
}
